module.exports = __webpack_public_path__ + "img/1019312.25448e96.jpg";